import { IAccountNavigation } from '@models/IAccountNavigation';
import AccountNavigation from '@molecules/AccountNavigation/AccountNavigation';
import { motion } from 'framer-motion';

const mobileMenuVariant = {
  opened: {
    x: '100%',
    transition: {
      delay: 0.15,
      duration: 1.1,
      ease: [0.74, 0, 0.19, 1.02],
    },
  },
  closed: {
    x: '200%',
    transition: {
      delay: 0.35,
      duration: 0.63,
      ease: [0.74, 0, 0.19, 1.02],
    },
  },
};

const AccountMenuMobile = (props: IAccountNavigation) => (
  <motion.div
    className="absolute top-0 right-0 bottom-0 left-0 overflow-y-auto"
    initial="closed"
    variants={mobileMenuVariant}
  >
    <div className="container w-full list-none text-black-100">
      <AccountNavigation {...props} />
    </div>
  </motion.div>
);

export default AccountMenuMobile;
